

import { get, post, patch } from './commonFetch';

import type { User, UserOrg } from '../types/user';

export const getAgent = (newAgentId?: number | null): Promise<User> => {
  return get(`/api/agents${newAgentId ? `/${newAgentId}` : ''}`);
};

export const updateAndGetAgent = (email: string): Promise<User> => {
  const postBody = { email };
  return post('/api/agents', postBody);
};

export const updateUser = (
  newUserId: string,
  active: boolean,
  role: string,
  assignedOrgNodeId: string,
  email: string,
  userName: string,
  userId: string
): Promise<User> => {
  const postBody = { newUserId, active, role, assignedOrgNodeId, email, userName, userId };
  return patch('/api/users', postBody);
};

export const createUser = (
  username: string,
  password: string,
  email: string,
  active: boolean,
  role: string,
  assignedOrgNodeId: string,
): Promise<User> => {
  const postBody = {
    username,
    password,
    email,
    active,
    role,
    assignedOrgNodeId,
  };
  return post('/api/users', postBody);
};

export const getUserOrg = (newUserId: string): Promise<UserOrg> => {
  return get(`/api/users/${newUserId}/orgs`);
};
//this is to list all Agent and Account Admin users from BE tripServices `/account/${accountId}/agents?${qs.stringify(queryParams)`
export const getAgentsAndAccountAdmins = (): Promise<User[]> => {
  return get('/api/users');
};
